import React from 'react';
import { styled } from '@linaria/react';

import LeftEdgeBase from './LeftEdgeBase';

function LeftEdgeTriangular() {
  return (
    <LeftEdgeBase>
      <SwoopySvg
        xmlns="http://www.w3.org/2000/svg"
        width={75 / 2}
        height={70 / 2}
        fill="none"
        viewBox="0 0 75 70"
        preserveAspectRatio="none"
      >
        <path
          fill="var(--color-page-background)"
          d="M54.3545 15.0483L46 0.5H0V64L5.42113 56.1695C7.66253 52.9319 11.3497 51 15.2874 51H33.542C51.9925 51 63.5426 31.0483 54.3545 15.0483Z"
          style={{
            transition:
              'fill var(--color-swap-duration) var(--color-swap-timing-function)',
          }}
        ></path>
        <path
          fill="var(--color-primary)"
          d="M52.1101 4.52096C51.2932 3.07946 49.4625 2.57308 48.021 3.38993C46.5795 4.20678 46.0731 6.03754 46.8899 7.47904L52.1101 4.52096ZM15 54H37.2466V48H15V54ZM0 63V69.5H6V63H0ZM46.8899 7.47904L53.777 19.6328L58.9972 16.6747L52.1101 4.52096L46.8899 7.47904ZM37.2466 54C56.4023 54 68.4412 33.3405 58.9972 16.6747L53.777 19.6328C60.9545 32.2988 51.8049 48 37.2466 48V54ZM15 48C6.71573 48 0 54.7157 0 63H6C6 58.0294 10.0294 54 15 54V48Z"
        ></path>
      </SwoopySvg>
    </LeftEdgeBase>
  );
}

const SwoopySvg = styled.svg`
  display: block;
  overflow: visible;
  margin-top: -1.5px;
`;

export default LeftEdgeTriangular;
